/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import { getHttpClient } from 'src/http-client';
const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export interface UpdateAutomationRuleDataType {
  id: string;
  name: string;
  status: string;
  organizationId: string;
  projectId: string;
  organizationName: string;
  actor: 'user' | 'service-principal';
  trigger: {
    type: string;
    data: any;
  };
  conditions: Array<{
    type: string;
    relationship?: string;
    data: any;
  }>;
  actions: Array<{
    type: string;
    data: any;
  }>;
}

export async function updateAutomationRulesService(args: {
  projectId: string;
  organizationName: string;
  automationRuleList: Array<UpdateAutomationRuleDataType>;
}) {
	try {
		const api = getHttpClient();
		const response = await api.put(`${apiUrl}/update-automation-rule/${args.organizationName}/${args.projectId}`, args.automationRuleList);

		return response;
	} catch (err) {
		console.error(err);

		if (isAxiosError(err)) {
			return err.response;
		}

		throw new Error('Failed to update automation rule.');
	}
}